
export class Oxygen{

    modele:string;
    fabriquant :string;
    capacite:string;
    quantite:string;
    prix:string;
    user:string;
    region:string;
    ville:string;
    tel:string;


}